<template>
  <v-layout class="xs-d-block" wrap>
    <!-- All -->
    <v-flex mb-3>
      <!-- Sets -->
      <table class="sets-summary table-responsive">
        <tbody>
          <tr>
            <th :colspan="match.setsTableData.subColumns.length + 2" class="white">
              {{ $t('page.match.match') }}
            </th>
          </tr>
          <tr>
            <th class="white" rowspan="3"><span /></th>
          </tr>
          <tr>
            <th class="white">
              <span />
            </th>
            <th v-if="match.boardDataMode !== 'basic'" :colspan="match.basePointControls.length">
              {{ $t('page.match.points') }}
            </th>
            <th :colspan="match.actionControls.length">
              {{ $t('page.match.actions') }}
            </th>
          </tr>
          <tr>
            <th>
              {{ $t('page.match.score') }}
            </th>
            <th v-for="(column, j) in match.setsTableData.subColumns" :key="`set_h2_${j}`">
              {{ $t(`sport.controls.${column.code}.short`) }}
            </th>
          </tr>
          <tr v-if="match.type !== 'baseballBase'">
            <th>{{ match.localTeamAcronym }}</th>
            <td class="bold">
              {{ match.setsTableData.rowTotL['score'] }}
            </td>
            <td v-for="(column, j) in match.setsTableData.subColumns" :key="`set_tl_${j}`">
              {{ match.setsTableData.rowTotL[column.code] }}
            </td>
          </tr>
          <tr>
            <th>{{ match.visitorTeamAcronym }}</th>
            <td class="bold">
              {{ match.setsTableData.rowTotV['score'] }}
            </td>
            <td v-for="(column, j) in match.setsTableData.subColumns" :key="`set_tv_${j}`">
              {{ match.setsTableData.rowTotV[column.code] }}
            </td>
          </tr>
          <tr v-if="match.type === 'baseballBase'">
            <th>FIX {{ match.localTeamAcronym }}</th>
            <td
              v-for="(data, j) in match.setsTableData.rowTotL"
              :key="`set_l_${j}`"
              :class="{ bold: j === 'score' }"
            >
              {{ data }}
            </td>
          </tr>
        </tbody>
      </table>
    </v-flex>
    <v-flex
      v-for="(set, i) in match.sets"
      v-if="i < 1 || (set.events && set.events.length > 0)"
      :key="`set_h1_${i}`"
      mb-3
    >
      <!-- Sets -->
      <table class="sets-summary table-responsive">
        <tbody>
          <tr>
            <th :colspan="match.setsTableData.subColumns.length + 2" class="white cursive">
              {{ match.setText }}
              {{ i + 1 }}
            </th>
          </tr>
          <tr>
            <th class="white" rowspan="3"><span /></th>
          </tr>
          <tr>
            <th class="white">
              <span />
            </th>
            <th v-if="match.boardDataMode !== 'basic'" :colspan="match.basePointControls.length">
              {{ $t('page.match.points') }}
            </th>
            <th :colspan="match.actionControls.length">
              {{ $t('page.match.actions') }}
            </th>
          </tr>
          <tr>
            <th>
              {{ $t('page.match.score') }}
            </th>
            <th v-for="(column, j) in match.setsTableData.subColumns" :key="`set_h2_${i}_${j}`">
              {{ $t(`sport.controls.${column.code}.short`) }}
            </th>
          </tr>
          <tr v-if="match.type !== 'baseballBase'">
            <th>{{ match.localTeamAcronym }}</th>
            <td class="bold">
              {{ match.setsTableData.rowsL[i]['score'] }}
            </td>
            <td v-for="(column, j) in match.setsTableData.subColumns" :key="`set_l_${j}`">
              {{ match.setsTableData.rowsL[i][column.code] }}
            </td>
          </tr>
          <tr>
            <th>{{ match.visitorTeamAcronym }}</th>
            <td class="bold">
              {{ match.setsTableData.rowsV[i]['score'] }}
            </td>
            <td v-for="(column, j) in match.setsTableData.subColumns" :key="`set_v_${j}`">
              {{ match.setsTableData.rowsV[i][column.code] }}
            </td>
          </tr>
          <tr v-if="match.type === 'baseballBase'">
            <th>FIX {{ match.localTeamAcronym }}</th>
            <td
              v-for="(data, j) in match.setsTableData.rowsL[i]"
              :key="`set_l_${i}_${j}`"
              :class="{ bold: j === 'score' }"
            >
              {{ data }}
            </td>
          </tr>
        </tbody>
      </table>
    </v-flex>
  </v-layout>
</template>

<script>
// const debug = require('debug')('OD::AdvancedStats')

export default {
  name: 'AdvancedStats',
  components: {},
  props: {
    match: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  beforeDestroy() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.sets-summary {
  th {
    padding: 0 5px;
    background-color: #ddd;
  }
  th.white {
    background-color: #fff;
  }
  td {
    background-color: #f8f8f8;
    text-align: center;
  }
  th.odd,
  td.odd {
    background-color: #f0f0f0;
  }
  th.even,
  td.even {
    background-color: #f8f8f8;
  }
  td.bold {
    font-weight: bold;
  }
}

.table-responsive {
  display: block;
  width: 100%;
  border: 0;
  overflow-x: scroll;
  overflow-y: hidden;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  -webkit-overflow-scrolling: touch;
}

.cursive {
  font-style: italic;
}
</style>
